import React, { useEffect, useContext } from "react";
import {
  Switch,
  Route,
  Redirect,
  useRouteMatch,
  useParams,
} from "react-router-dom";
import axios from "axios";
import Disclaimer from "./Disclaimer.js";
import PropertySearch from "./PropertySearch";
import ViewItem from "./ViewItem";

import { Context as PropertyContext } from "../../context/property.context";
import { Context as CartContext } from "../../context/cart.context";

var qs = require("qs");

let invoicePaid = false;

const Property = (props) => {
  const { state, searchTaxBills, readTaxBill } = useContext(PropertyContext);
  const { removeFromCart } = useContext(CartContext);
  let { path } = useRouteMatch();
  let { opID } = useParams();

  useEffect(() => {
    window.addEventListener("message", (message) => {
      console.log("IN EVENT LISTENER");
      receiveMessage(message);
    });
  }, []);

  const receiveMessage = (message) => {
    console.log("THIS POSTBACK MESSAGE", message.data.operation);
    let searchText = localStorage.getItem("searchText");

    if (message.data.operation === "approval") {
      // console.log("POSTBACK MESSAGE");
      // document.body.scrollTop = 0; // For Safari
      // document.documentElement.scrollTop = 0;
      invoicePaid = true;
    } else if (message.data.operation === "closemodal") {
      console.log("CLOSE MODAL POSTBACK MESSAGE", invoicePaid);

      if (invoicePaid) {
        refreshLightbox({
          buttonColor: props.theme.palette.secondary.main,
        });

        removeFromCart({ all: true });

        searchTaxBills(searchText, true);

        readTaxBill(localStorage.getItem("invoiceID"));
      }
      //alert(document.body.style.backgroundColor);
      //document.body.style.backgroundColor = "pink";
    }
  };

  const refreshLightbox = async ({ buttonColor }) => {
    // setSelected([]);
    // setPaymentTotal(0.0);
    const options = {
      method: "POST",
      headers: { "content-type": "application/x-www-form-urlencoded" },
      data: qs.stringify({
        params: `{}`,
      }),
      withCredentials: true,
      url:
        !process.env.NODE_ENV || process.env.NODE_ENV === "development"
          ? "https://brandonshepherd.cpteller.com/api/onetaxapi.cfc?method=refreshLightbox"
          : `https://${window.location.hostname}/api/onetaxapi.cfc?method=refreshLightbox`,
    };

    const intellipayResponse = await axios(options);

    if (!intellipayResponse.data.session) {
      let opID = localStorage.getItem("opID");

      const hydrateTerminalResponse = await axios({
        method: "post",
        url:
          process.env.NODE_ENV || process.env.NODE_ENV === "development"
            ? "https://brandonshepherd.cpteller.com/api/onetaxapi.cfc?method=refreshLightbox"
            : `https://${window.location.hostname}/api/onetaxapi.cfc?method=refreshLightbox`,
        data: qs.stringify({
          method: "hydrateTerminal",
          opID,
        }),
      });

      console.log("REFRESH REPONSE", intellipayResponse.data.lightbox);
      eval(intellipayResponse.data.lightbox);
      invoicePaid = false;
    } else {
      console.log("REFRESH REPONSE", intellipayResponse.data.lightbox);
      eval(intellipayResponse.data.lightbox);
      invoicePaid = false;
    }
    // console.log("REFRESH RESPONSE", window.intellipay);
  };

  return (
    <div style={styles.container}>
      <div style={styles.content}>
        <Switch>
          <Route exact path={`${path}/accept_terms`}>
            <Disclaimer />
          </Route>
          <Route exact path={`${path}/search_records`}>
            <PropertySearch />
          </Route>
          <Redirect from={`/${opID}`} to={`/${opID}/accept_terms`} exact />
          <Route exact path={`${path}/view_record/:id`}>
            <ViewItem />
          </Route>
          <Route path="*">
            <div>No Match</div>
          </Route>
        </Switch>
      </div>
    </div>
  );
};

const styles = {
  container: {
    width: "100vw",
    display: "flex",
    justifyContent: "center",
    marginTop: 110,
    paddingBottom: 100,
    background: "#eff3f9",
    minHeight: "100vh",
  },
  content: {
    maxWidth: 1300,
    width: 1300,
    textAlign: "left",
  },
};

export default Property;
